<template>
  <div class="login-wrapper">
    <!-- <video id="VidageVideo" class="bgVideo" preload="metadata" loop="" autoplay muted="">
      <source class="bgVideoSource" src="http://192.168.1.139:8088/images/bg.mp4" type="video/mp4">
    </video> -->
    <div class="bgImg"></div>
    <div class="wrapper">
    <div class="login">
        <span class="logo">
            <!-- <img src="../assets/images/ideal_logo.png"> -->
            <h5>全服到家后台管理系统</h5>
        </span>
        <span class="login_input">
            <!--<h5 style="margin-bottom: 10px;">欢迎登陆：</h5> -->
            <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm loginFrom" :rules="rules">
                <el-form-item prop="userName">
                    <el-input clearable placeholder="账号" autocomplete="off"  v-model.trim="ruleForm.userName" prefix-icon='iconfont hohofast-zhanghao'></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input clearable type="password" autocomplete="off" v-model.trim="ruleForm.password" placeholder="密码" prefix-icon='iconfont hohofast-login_mima'></el-input>
                </el-form-item>
                <!-- <el-form-item prop="imgCode">
                    <el-input v-model.trim="ruleForm.imgCode" autocomplete="off" placeholder="请输入验证码" @keyup.enter.native="submitFormTest('ruleForm')">
                        <el-button slot="append" @click="createCode">{{verificationCode}}</el-button>
                    </el-input>
                </el-form-item> -->
                <div class="clearfix">
                    <div class="fl">
                        <el-checkbox v-model="checked" style="color:#a0a0a0;margin-bottom: 20px;">记住账号密码</el-checkbox>
                    </div>
                    <span>{{codeMessage}}</span>
                    <el-button type="primary" @click="submitFormTest('ruleForm')" style="width: 100%;">登录</el-button>
                </div>
            </el-form>
        </span>
        <div class="clearfix"></div>
    </div>
    <div class="clearfix"></div>
    <div class="footer_login">
        <ul>
            <li><a href="javascript:SetHome(this,window.location);">设为首页</a></li>
            <li><a href="javascript:bookmark(document.title,window.location);">加入收藏</a></li>
            <li><router-link to="/HelpPage">帮助</router-link></li>
            <li><a href="/?lang=en_US">English(US)</a>&nbsp;&nbsp;&nbsp;<a href="/?lang=zh_CN">简体中文</a></li>
        </ul>
        <p> Copyright&nbsp;上海全服通信技术有限公司&nbsp;©&nbsp;2016-2026&nbsp;版权所有。</p>
    </div>
</div>
  </div>
</template>
<script>
    import { login,verifyCodeServlet,resultServlet,logout } from '../api/api'
    import store from '../store/store'
    import 'font-awesome/css/font-awesome.min.css'
    export default {
        name: 'login',
        inject: ['reload'],
        data () {
            var validateImgCode = (rule, value, callback) => {
                value = value.toUpperCase();
                if (value === '') {
                    callback(new Error('请输入验证码'))
                } else if (value !== this.verificationCode) {
                    callback(new Error('验证码不正确，请重新输入'))
                } else {
                    callback()
                }
            }
            return {
                codeMessage: '',
                inputInfo:'',   //用户输入信息
                verificationCode:'',   //生成的验证码
                ruleForm: {
                    userName:'',//用户名
                    password: '',  //密码
                    imgCode:''//验证码
                },
                rules: {
                    userName: [{required: true, message: '请输入账号', trigger: 'blur'}],
                    password: [{required: true, message: '请输入密码', trigger: 'submit'}],
                    imgCode: [
                        {validator: validateImgCode, required: true,trigger: 'submit'}
                    ]
                },
                loginStatus:true,
                checked:true,
                title: '注册',
            }
        },
        mounted () {
            this.createCode();
            this.getCookie();
        },
        methods: {
            //通过随机数生成验证码
            createCode:function () {
                //通过随机数生成验证码
                this.verificationCode = '';
                var code = ''; var codeLength = 4;
                //验证码长度
                var random = new Array(0,1,2,3,4,5,6,7,8,9,'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R', 'S','T','U','V','W','X','Y','Z');
                for(var i = 0;i<codeLength;i++){
                    var index = Math.floor(Math.random()*36);
                    code += random[index];
                }
                this.verificationCode = code
            },
            //验证函数
            confirmTheCode:function () {
                //验证函数
                var customerCode = this.ruleForm.imgCode.toUpperCase();
                //把你输入的小写转化为大写
                if(customerCode == 0){
                    this.createCode();
                    this.ruleForm.imgCode = ''
                    // this.codeMessage = '请输入验证码'
                    this.$message({
                        message: '请输入验证码',
                        type: 'warning'
                    });
                }else if(customerCode != this.verificationCode){
                    this.createCode();
                    this.ruleForm.imgCode = '' ;
                    this.$message.error('验证码不正确，请重新输入');
                }else {
                    this.codeMessage = '验证码输入正确'
                    this.$message({
                        message: '验证码输入正确,请登陆',
                        type: 'success'
                    });
                    this.loginStatus = false
                }
            },
            submitFormTest(formName){
                // console.log(this.ruleForm)
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.checked == true) {
                            //传入账号名，密码，和保存天数7个参数
                            this.setCookie(this.ruleForm.userName, this.ruleForm.password, 7);
                            this.login()
                        }else {
                            // console.log("清空Cookie");
                            //清空Cookie
                            this.clearCookie();
                            this.login()
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //登录
            login(){
                let para = {
                    loginName: this.ruleForm.userName,
                    password: this.ruleForm.password
                };
                login(para).then(res => {
                    // console.log(res.data.status)
                    if (res.data.status == 100) {
                        this.$message({
                            message:res.data.message,
                            type: 'success'
                        })
                        let data = res.data.results;
                        this.$store.commit('set_token', data["token"]);
                        // console.log(store.state.token)
                        if (store.state.token) {
                            localStorage.setItem('userInfo', JSON.stringify(res.data.results.userInfo));
                            localStorage.setItem('authList', JSON.stringify(res.data.results.authList));
                            localStorage.setItem('menuList', JSON.stringify(res.data.results.menuList));
                            this.$router.replace('/welcome');
                            this.reload();
                            this.$router.go(0);
                        } else {
                            this.$router.replace('/');
                        }
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            //设置cookie
            setCookie(c_name,c_pwd,exdays) {
                var exdate=new Date();//获取时间
                exdate.setTime(exdate.getTime() + 24*60*60*1000*exdays);//保存的天数
                //字符串拼接 cookie
                window.document.cookie="userName"+ "=" +c_name+";path=/;expires="+exdate.toGMTString();
                window.document.cookie="userPwd"+"="+c_pwd+";path=/;expires="+exdate.toGMTString();
            },
            //读取cookie
            getCookie:function () {
                if (document.cookie.length>0) {
                    var arr=document.cookie.split('; ');//这里显示的格式需要切割一下自己可输出看下
                    for(var i=0;i<arr.length;i++){
                        var arr2=arr[i].split('=');//再次切割
                        //判断查找相对应的值
                        if(arr2[0]=='userName'){
                            this.ruleForm.userName=arr2[1];//保存到保存数据的地方
                        }else if(arr2[0]=='userPwd'){
                            this.ruleForm.password=arr2[1];
                        }
                    }
                }
            },
            //清除cookie
            clearCookie:function () {
                this.setCookie("","",-1);//修改2值都为空，天数为负1天就好了
            }
        },
    }

</script>
<style scoped>
    @import '../assets/css/userOpt.css';
    .user-input-wrapper .ivu-input-icon.ivu-icon-eye,
    .user-input-wrapper .ivu-input-icon.ivu-icon-eye-disabled {
        top: 5px;
        left: 330px;
    }
    .code-box{ margin-top: 50px; text-align: center; }
    .code-style{ font-size: 16px; color: red; cursor: pointer; }
    .confirm-botton{ display: inline-block; width: 50px; background-color: #04b4ba; font-size: 16px; line-height: 32px; cursor: pointer; }
    .el-form .el-form-item .el-form-item__content+.is-error .el-form-item__error{font-size: 14px!important;}
</style>



// WEBPACK FOOTER //
// Login.vue?e4e3aeb2